import { sampleSize, split, range, map, capitalize } from 'lodash'

/**
 * Fce pro vygenerovani zapomatovatelneho hesla z ceskych slov a pismen
 * @param {Integer} wordsCount pocet slov v hesle
 * @param {Integer} numbersCount pocet cisel v hesle
 * @return {String} vygenerovane heslo
 */
export default function generatePassword(wordsCount = 3, numbersCount = 3) {
    const words = split(WORDS, '\n')
    return map(
        [...sampleSize(words, wordsCount), ...sampleSize(range(0, 9), numbersCount)],
        w => capitalize(w)
    ).join('')
}

const WORDS = `
absolutismem
abstinuje
adamou
adjutant
adresovou
aerostatika
agitek
agronomu
akceptant
akredituj
aktivit
akumuluju
alb
alergen
algoritmizuj
aloiska
altruisty
aminokyselinami
amsterodam
analyzujme
andulku
anglikanismus
anketkou
antecedence
antihrdinovo
antiraketou
antonymy
apelem
apollem
aquaparku
archeologu
aretujete
aritmetikou
artistickou
asiatky
askeze
astigmatickou
astronomickou
atipu
atrakci
audiovstup
autentifikaci
autodopravci
automapou
autonehody
autoskel
axiomatickou
bacilu
bajce
baletka
bambulkami
bantuskou
barka
barviteln
basketbalistou
batyskafu
bednou
bentonitem
berounskem
betonovala
bezmasou
bezzubosti
bigamistce
bioethanol
bioplasty
bistro
blahech
blbostem
bliky
bloumavou
bobulka
boeingu
bohuslave
bol
bonifikovat
borovicemi
boubelkou
bozp
bratislavane
brejle
brno
broukal
brusem
bublifuk
buditele
bujet
bum
buvolem
byrokraticky
cajkovskij
cedry
celnic
cenami
centrovat
cesia
chalup
charizmatu
chemikova
chladivost
chloridech
chobotnatci
cholovou
chorvatum
chrchel
chroust
chudoba
chybily
cibulka
cinkavou
citovkou
cizinou
cop
csav
cukernatost
curia
cyklistko
cynicky
daktyl
danovo
datlemi
ddm
debutem
dedikoval
definovali
defrauduji
dehydruji
deklasuj
dekret
deltami
demoduluji
demonstruj
denoxidace
deprimoval
deseti
deskriptivou
detailu
deuteron
dezertovat
diabetici
dialogy
diferencujou
diletantkou
diplomaty
disidentskou
diskutovat
distancovali
diverzifikujeme
dloubne
dobelhala
dobrodruhy
dobyty
dochytal
dodranou
dohasit
dohotoveny
dojednal
dokladatelnou
dokopat
doktorandek
dokutili
dolnorakouskou
dominikem
domorodka
donoru
dopekli
doplave
dopracujte
doprovodnou
dorota
dosednou
dosprintovalo
dostudoval
dotazovala
dotud
doveden
dovoluje
dozimetrickou
drahomira
drancovanou
driblovali
drobotinu
druhovo
duchem
dumavou
dusadlem
dvojakost
dvojnou
dvoudenne
dvousemestrovou
dysgrafikem
edituji
eidou
ekonomko
elektrifikoval
elektromagnetismem
elektroskopem
elipsovitou
emigranty
empirik
energoplynu
epidiaskopu
eposem
erotomanou
eskontu
etablujme
etku
eufemismus
euroskepse
evidovala
excelovaly
exhibovat
exministra
experimentuj
exponujete
exteriorita
extrou
fakticky
fanatiku
farma
fatalisty
fazolky
feminizovanou
fermionech
fiaskem
filek
filozofovala
financujte
fitko
fleretu
flow
fondech
formalizovat
fosforeskuje
fotocitlivosti
fotokazetou
fototyristor
franciem
freewarovka
fronta
fungujme
fytogeografie
galantnosti
gangou
gayem
genialitou
geoidu
germanistovu
gibraltarskou
globalizaci
golfisty
grafem
gramotnou
grenadou
guinejskou
gynekologicky
hadr
halenkou
handlovali
harfa
hasivou
hazarduju
hekala
helmy
hercovu
heterocyklickou
hipodromem
hitovkou
hlasivek
hleena
hloubkovou
hmatanou
hnojivy
hocha
hodovou
holdovanou
holotou
homolkami
hopem
hormony
hospitalizujete
hostovali
houklou
hovadinou
hradidlovou
hrbilo
hrobek
hroutila
hryzala
hudebnin
humor
husopasem
hydranty
hydrometrickou
hynuly
hypnotikou
hyzdily
identitu
ignorant
ilusi
imitovalo
imploduje
impuls
indianistkou
indukovala
infiltrujte
ingoty
inkasista
inovativnosti
inspiromat
instrumentovanou
intenzitou
internete
interpretkami
intrikovalo
inventur
inzeruj
iritace
isterstvo
izobarickou
izraelkou
jakpak
japanistou
jasnost
jdouc
jednohlas
jednotce
jehlu
jemnovlnne
jezdecnou
jihokorejci
jist
jmenovkami
jotou
judo
justici
kachnou
kajmanovi
kalenou
kalkulujete
kameniny
kamizola
kandovat
kantorovu
kapitalisticky
kapounkovou
karas
kardiaci
karkulkou
kartografii
kastroval
katapulty
katodou
kazatelnu
kecali
keratinu
kilowatthodinou
klackovitosti
klamnost
klasifikovaly
klejt
klepetem
klidila
klikorohu
klitorisu
klopnou
klukem
kmoch
koagulovat
kocourou
kohos
koketujte
kolaborantovo
kolegovy
kolikero
kolonizace
kolumbovy
komedianty
komoditizace
kompenzoval
kompliment
komprimovali
komunistek
koncertech
kondolujete
konfiskace
koniferou
konoid
konstatoval
kontaktovaly
kontrabasech
kontrolou
konvertibility
konzervatoristou
konzumaci
kopaninou
koptem
korektiv
korku
kortizola
kosatkami
kosmopolitismem
kotcem
koukolovou
kousky
kovo
krachly
krajky
krasnojarskou
krechtovat
krevel
kritikou
krocen
krotitele
krup
kryotherapie
krystof
kudlat
kulhavce
kultovou
kupci
kursista
kutily
kvantem
kvasnice
kvizovou
kynolog
kytem
labradorit
laickost
lamelami
lanovod
laserovou
laurou
lechovice
ledvice
legitimizoval
lejstry
lemujte
lepenkou
lesknete
letmou
levitace
lhotkou
libosti
licitovali
ligista
limbou
linkovanou
lisovali
litinou
loajalitou
logaritmicko
lokalizoval
lomilo
lososi
loukov
lovtou
luhu
lupovitost
lvi
macek
magdin
magnitudo
majority
makroekonomie
malesickou
malvidin
mandarinku
manipulant
mapujeme
marinujeme
marsy
masech
mastily
materie
maturovat
mazec
mechaniky
medializovaly
megabytou
melanomech
memorovaly
merkaptan
metaloid
meteorologa
metrologicky
mezijev
mezopotamskou
mikinou
mikrogram
mikroprogramovat
mikulov
milimetrem
milujete
minesengr
minimalisticky
ministryni
mirkou
mixem
mlatci
mluvnost
mnohosektorovou
mocnostech
moderovat
modulou
molinovou
moniliovou
monolog
montecassinskou
moralizuju
morfometrie
mosty
motoricky
mouchu
mravencovu
mrskali
mstil
muldou
mumiovou
muzikantem
myoglobin
mystifikuji
nabiflovaly
nabouchal
nacenit
nacionalisty
nadchl
nadetekuje
nadjel
nadpisem
nadstavby
nafaxovali
naftalenovou
nahnanou
nahrazujeme
naivistka
nakapala
naklopen
nakopnuli
nakrimpujeme
nakumulovat
nalehlo
naleznulo
nalosovala
namenal
namontuj
nanofaradu
naorganizovala
napatinovat
naplavujou
napohlavkovaly
naposledy
napsala
narkomani
narubu
nasedne
naskytovala
nasprejovala
nastolovanou
nastydnem
natahanou
natlouklo
naucic
navigaci
navozujeme
navzdor
nazvaly
neakceptuji
neamputovala
neasimiluji
nebankrotujete
neblafovala
neboduje
neboxoval
nebudujete
nechal
nechrlila
necitovala
neculila
nedeaktivujete
nedeklarovala
nedeptaly
nediktovali
nedistribuovali
nedocenit
nedohazejou
nedojeti
nedokreslujeme
nedomluvilo
nedopalovala
nedopomohlo
nedorosteme
nedostahovalo
nedotankujete
nedoutnala
nedozvonily
nedutou
neeviduj
neexportujte
nefilozofovali
nefotila
negativistickou
nehasne
nehlesl
nehoblovali
nehorlila
nehratelnou
nehustila
neimplementoval
neinformovali
neintegrovala
neironizoval
nejezdili
nejvyuzitejsi
nekanibalizovali
neklamala
neklesnu
nekoherentnost
nekomentovali
nekompromitovaly
nekonstatovala
nekonzistentnosti
nekorodovala
nekouzlily
nekrotil
nekvalifikovaly
nelapila
neleptal
nelinearita
neloupala
nemanipulovat
nemazlil
nemizely
nemoderuje
nemou
nemusela
nenabodnou
nenadchli
nenadzvedla
nenahodili
nenajeti
nenakrmeni
nenalinkovaly
nenamrzl
nenapilo
nenaposlouchalo
nenasadilo
nenasoukaly
nenastupoval
nenatrhali
nenavozovala
nenechte
nenutit
neobelstilo
neobklopoval
neobohacuje
neobstaral
neocenili
neocitaly
neodcestujou
neodeberte
neodhadli
neodhrnete
neodkopla
neodlil
neodolalo
neodplulou
neodpustila
neodsouvali
neodsuzuji
neodvezte
neohlodali
neohrnovalo
neokopala
neolizoval
neomladili
neopadala
neopisuje
neopovrhovalo
neorala
neosazuju
neoslepnete
neosvojoval
neotrkali
nepacifikujeme
neparsovat
nepilo
neplazilo
nepobavily
nepochopitelnost
nepodchladilo
nepodjela
nepodnikly
nepodrtil
nepodvedly
nepohoda
nepojedete
nepokoji
nepolekala
nepolykejte
neponesou
nepopostrcice
neporazil
neposkvrnily
nepostaraly
neposuzovaly
nepotulovaly
nepovolala
nepozastaveni
nepozvu
neprecizoval
neprobouzelou
neprodukovani
neprohodili
neprokazuje
neprolamujete
nepromrzly
nepropaguju
nepropukneme
neprosolovala
neprotkaly
neprovolal
neptunem
neradit
neredukovalo
nerekapitulovalo
nereplikovaly
nerezidentou
neroutuji
nerozcupujete
nerozeslaly
nerozhoupalou
nerozkradly
nerozmazluju
nerozpakujte
nerozproudilo
neroztancovala
nerozveselila
nervovou
neschudlo
nesejmuly
nesesadit
nesesypali
neshrabali
neskandovali
neskonalou
nesleduji
nesmekl
nesnesl
nesouviseti
nespekuluji
nespojovaly
nesportoval
nesrkej
nestanovovala
nestimulujeme
nestranilo
nestudovaly
nesvazuje
nesynchronizuj
netankujte
netikety
netolerujme
netrnou
netvorovo
neuchlastalo
neudivilo
neuhnulo
neukamenovali
neukotvily
neukvapujte
neunavila
neupijete
neupozadily
neurobiologii
neurozenou
neusetric
neusrkli
neutahovani
neutralizovalo
neuvazovalo
neuzemnili
nevedete
nevibruje
nevneseni
nevpisuje
nevsadila
nevybaleni
nevyblila
nevybudovani
nevychutnali
nevydrolila
nevygumovala
nevyhodil
nevyhrazujou
nevyjmenujeme
nevyklouzlo
nevykoupil
nevykupovala
nevylisujte
nevymetete
nevymrzne
nevynesete
nevypiji
nevyplo
nevypravuji
nevypumpovaly
nevyrvat
nevyskytujeme
nevystavovaly
nevysune
nevytekla
nevytrhnu
nevyventilujeme
nevyzbrojovala
nevzbudily
nevzmohlo
newtonovy
nezabodl
nezacementovalo
nezadrhlo
nezahesluje
nezahrnovalo
nezajme
nezakopalo
nezakuckali
nezalgoritmizovaly
nezamezuje
nezamrzlo
nezaoblily
nezapisovat
nezapojily
nezareaguju
nezasedalo
nezasponzorovala
nezasunula
nezateplete
nezatrhneme
nezavdal
nezavrhujte
nezbil
nezchlazena
nezdeptala
nezdrbala
nezetlelo
nezhorsice
neziskovek
nezkolabuju
nezkonstruovani
nezkracovani
nezlevnilo
nezmoci
neznaly
neznovelizovaly
nezorientovaly
nezpolitizovalo
nezpropagujte
nezrcadlila
nezrestaurovaly
neztmavne
nezvedal
nezvrhly
nikity
nitrobenzen
noclehovat
nomogramy
normohodinou
nostrifikovali
novem
novoty
nuklidu
nymburce
obcani
obdivovatelovou
obepjali
obhajte
objektivech
objezdovou
oblastmi
obloukovek
obnovujou
obracela
obrobenou
obsadil
obstaralou
obuch
obvolanou
ocelolitiny
ochodu
ochucujete
octne
odblokujetou
odcestovaly
odchytla
oddechly
oddychuji
odendat
odevzdat
odhadce
odhlasme
odhrnula
odkazuj
odklouzalo
odkriminalizovali
odkvetenou
odleva
odlupovanou
odmlku
odnacizovat
odpadnu
odplaty
odplynovat
odposlouchal
odpumpovali
odreagovala
odsadila
odsoudil
odstavujou
odsunovala
odtekl
odvalovou
odvezl
odvozem
odzbrojeno
ofoukat
ohluchly
ohodnotily
ohromeny
okapem
okolku
okousala
okrouhat
okusilo
olemujme
oloupeni
ombudsmankou
omladinu
omrzely
onen
opalizovalo
opatu
opije
oplakat
opomenuti
opotilo
opravnu
optimalizujeme
opylovanou
oregonskou
orientujete
orotujeme
osamocen
osedlat
oskenujete
oslepily
osmibitovou
osnovatelem
osprchujou
ostruhami
osvojenou
oteplili
otloukalo
otrokem
outsourcujete
ovsou
ozdobily
ozubnice
pacifikovat
pagina
palby
paliv
panamu
panovat
paprika
parakrezol
parametry
parcel
parkuru
partenogenicky
pasivech
pastorku
patic
patriotku
pavlovy
pedantsky
peletou
pentelkou
perestrojku
peristaltika
pernou
perun
peticemi
pharmdr
pigmentu
piksla
pilulka
pistol
pivovarem
placky
planuly
plavali
plazmid
plenovou
pletly
plnit
plomby
plujou
plynoprachovou
pobarvenou
pobodat
pochmurnosti
pochva
poctili
podbarvuji
podebereme
podexponujte
podivoval
podkope
podlepili
podnapileji
podobiznu
podpisovaly
podprojekty
podrubriky
podstavnou
podtituly
podvedeni
podzemky
pohan
pohledkou
pohony
pohrdnout
pohybovkou
pojistitelka
pokladech
poklidili
pokosilo
pokryji
pokyvovalo
polechtejte
poletovaly
polijete
polkly
polohy
polopostavy
polucemi
polymorfismu
pomatenosti
pomoc
ponechali
poodhalenou
popadneme
popisovaly
popojdeme
popravu
populisticky
porcujme
porotcovo
portugalskem
poselstvu
poskvrnou
poslepovali
posprejovala
postihly
postrasice
posumavi
posyptou
potlachala
potrav
potvrdili
pout
povedlo
povolnost
povytahovat
pozastaveni
pozemkou
poznej
pozvracet
pragmalingvistika
praktikum
prapory
pravice
prcinka
preferovanou
preparovali
pretocice
prikrocic
priorita
prkotinu
probodnu
procentem
proclilo
prodlev
profanace
profitabilita
programuji
prohlubenin
prohraji
projektantou
prokain
proklestit
prokopla
prokulit
prolistovalo
promarodit
promluvy
promyslela
proniknuta
propaluje
proplakal
propojeno
propukalo
prorokuju
prosekne
proslulosti
prostitut
prostupem
protancuje
protestovali
protimluvech
protivzorek
protoplazma
provazovou
provlhlo
provrtala
prskaly
prvkovou
pseudogoticky
psst
psychologii
ptej
pudinkovou
pulsovou
pupkatou
putovaly
pyropovou
rachotily
radil
radiosondou
radonu
rajtky
rampouchu
rasistovu
razii
realistou
recenzentem
recitativ
redukcionismu
refinancovala
reformy
registrujete
reinstaluji
reklamka
rekonstruuju
rektorce
relativizovala
remitence
rentabilita
repatriacemi
reprezentantou
reputace
responsou
restrukturalizujou
reverzovat
revolta
rezignuju
rigidita
rizik
robotovou
rohane
rokuji
romanizace
rosa
rotovala
rour
rovnostmi
rozbolelo
rozcouranou
rozdrtila
rozejde
rozesel
rozezleni
rozhleden
rozhoupeme
rozjely
rozkodrcanou
rozkreslovanou
rozleptat
rozlousknuty
rozmlouvala
rozmrzelou
rozorat
rozpisovanou
rozpojit
rozpracovaly
rozpuklina
rozryje
rozsochou
roztavilo
roztrousili
rozvede
rozvleklou
rozvrstvili
rubopisem
rudou
rumunskem
rustika
rychlokurzem
rysce
sachalin
sakristiemi
samaria
samorost
sanacemi
sarka
saturnina
sbalila
schematismem
schovejte
scuknete
seberealizuje
sedel
sedmisekundovou
seismicitou
sekl
sel
semetrik
senes
senzualitou
septiliarda
servobrzdou
seskupeny
sestavujme
sesunula
setrvalou
sexuologu
sfouknete
shnila
shrbit
signalizujou
silviin
singularita
situa
skafandru
skanzeny
skepticky
skladeb
sklerotika
sklouznetou
skoncice
skousnete
skulinkou
slabikuj
slanila
sledovalo
slety
slinilo
slivovicovou
sloupat
slovenskou
sluncem
smeknou
smlslo
smrkala
smyslit
snoubenek
socialista
sodovky
sokovi
somatopedie
sorabistou
soudky
soupisek
soustruhovali
spalme
spatric
spektrech
spermiogramu
spisovatelky
splavovalo
spojem
spokojila
spolufinancuje
spolupracovat
spontaneita
spoty
sprejerku
srab
srnky
ssr
stalina
stanovila
starokomunista
statikou
stavitele
stejnopisech
stereofonie
stevardova
stiskne
stohovanou
stolujete
stopuje
strachu
stravovali
strhli
strojmistrovi
struktogram
studentek
stupiditu
stylistu
subkomponentou
subvence
sugestivnost
sumerskou
superlize
supluje
suspenze
svastikami
svedly
svitavy
svolovali
sychravou
symetrizace
syndikace
syntetiky
systemizovat
tachometrem
tajit
tamarou
tankistovi
tarifikujete
tatru
teatrology
teista
telegrafie
teleport
temnotami
tenistovu
teoretizovali
terabitovou
terezou
termoset
teslovi
tetralogie
thaliovou
tiketem
tiskopisem
tkadlenami
tlemila
tmavly
tolar
tonerem
topolog
touhle
tradic
traktoristou
transfuzi
transuranovou
traumatizovalo
trendu
trhl
tridentskou
tritia
trnovou
trojmetrovou
trosku
trsy
trumfovalo
trylkovat
tukanou
tupozrakosti
turnus
tvorem
tygrovitou
tyranizujte
ubohou
uchechtat
uchylte
udejme
uf
uhlazenost
uhrabal
ujdou
ukazovat
ukojenou
ukradl
ukrutnou
ulekli
ultrabazickou
umlela
umyjme
unifikovaly
uno
upgradovala
uplavou
uposlechnete
uprdli
urguje
urychlovali
usedla
uslintat
usnuly
ustanoveny
ustrouhali
utajila
utiskujte
utopismu
utvrzovat
uvez
uvyknutou
uzlinami
vady
validitu
vanou
varnu
vby
vdupu
vejde
veletrhy
velkoprodejna
vemeny
veplout
verunka
vestibulum
vhazovali
viceprezidentem
videoklipu
vidimaci
viktorie
vinout
visejic
vizme
vkroutit
vlastimilovo
vlezu
vlnovkami
vnada
vnucujete
vodotiskem
vokalistu
volila
vosa
vpal
vpochoduji
vratimov
vrdy
vrtaly
vrzem
vstupenkou
vtipkovanou
vulkanologickou
vybarvil
vyblbli
vybourali
vybudit
vycestovala
vychrchlanou
vycouvejte
vydechovala
vydobytou
vyejakuloval
vyfiltruj
vygradovanou
vyhlasovali
vyhodily
vyhov
vyhrknul
vyhulilo
vyjma
vykazuju
vykloubila
vykomunikovat
vykoumal
vykresleno
vykuchanou
vyladila
vylicitovat
vylouhovalo
vyly
vymezujeme
vymontuj
vynadej
vynesme
vyobrazovaly
vypekli
vypla
vyplenily
vypnula
vypoulily
vypreparovalo
vyprsknete
vyrabovalo
vyrovnaly
vyschly
vyskytlo
vyslovovat
vysoudili
vystartujete
vystonejme
vystudovanou
vysvoboditeli
vytapetoval
vytisknou
vytrestal
vytuhli
vyvalujete
vyvinete
vyvrcholila
vyzbrojit
vyznamenat
vyzvednut
vzdala
vzduchovka
vzletnosti
vzorkovou
vztahovaly
waypoint
wmf
xylit
zabalilo
zabij
zabodnu
zabrousil
zabydluju
zachybovala
zacpete
zadinovou
zadupla
zafungovanou
zahanbujou
zahloubenou
zahrabaly
zahrozil
zainteresoval
zajickach
zakecala
zaklesnulo
zakonzervovanosti
zakousne
zakrytovalo
zakurvil
zalehneme
zaleztou
zalkla
zamaluju
zamezujte
zamnout
zamumlej
zanesete
zaokrouhluj
zapamatujme
zapisujou
zapletli
zapojte
zaprotestovanou
zareaguj
zaros
zasalutuj
zasilatel
zasluhuji
zastanete
zastrasice
zasurfovala
zatajujou
zateplily
zatnulo
zatroubili
zaujme
zavazovaly
zavinuly
zavrzaly
zaznamenat
zbavte
zbohatnete
zbudu
zchromenou
zdaru
zdenek
zdlouhou
zdraven
zdrv
zeditovanou
zenerovou
zesumarizovanou
zformalizovat
zhlouplo
zhotovitel
zhrzeno
zidealizovaly
zinscenovala
zjevem
zkazil
zkomolenou
zkompromitujete
zkonstruovalo
zkoordinovali
zkoumou
zkreslen
zkroutil
zlatistou
zlikvidovaly
zlomyslnosti
zmastila
zminimalizovalo
zmodernizujeme
zmrtvit
znamenitosti
znekolauduje
znojemskou
zobejme
zohavily
zoptimalizovaly
zotavila
zpevni
zpohlavkovat
zpozdilou
zpravodajovu
zprznil
zranitelnost
zredigovat
zrekonstruujou
zrestartovat
zrozenou
zsinalo
ztopila
ztuhnula
zumby
zvelebovaly
zvoltou
zvrzal
`
